<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BfeMVY/tc-custom/9780062300201.jpg?1731883518480" alt="This image is the cover for the book End of Days"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">End of Days
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>End of Days</i>, James L. Swanson, the <i>New York Times</i> bestselling author of <i>Manhunt: The 12-Day Chase for Lincoln's Killer</i>, brings to life the minute-by-minute details of the JFK assassination—from the Kennedys' arrival in Texas through the shooting in Dealey Plaza and the shocking aftermath that continues to reverberate in our national consciousness fifty years later.</p><p>The assassination of John F. Kennedy on November 22, 1963, has been the subject of enduring debate, speculation, and numerous conspiracy theories, but Swanson's absorbing and complete account follows the event hour-by-hour, from the moment Lee Harvey Oswald conceived of the crime three days before its execution, to his own murder two days later at a Dallas Police precinct at the hands of Jack Ruby, a two-bit nightclub owner.</p><p>Based on sweeping research never before collected so powerfully in a single volume, and illustrated with photographs, <i>End of Days</i> distills Kennedy's assassination into a pulse-pounding thriller that is sure to become the definitive popular account of this historic crime for years to come.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Swanson
      </h2>
      
      <p class="authorDescription body article"><P>James Swanson is the Edgar Award-winning author of the <I>New York Times</I> bestsellers <I>Manhunt</I> and its sequel, <I>Bloody Crimes</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cea8380